import { createFileRoute, Navigate } from '@tanstack/react-router';

import { TagDefinitionsSection } from '@apps/web/components/settings/tag_definitions_section';
import {
    SettingsPageShell,
    useSettingsGates,
} from '@apps/web/features/settings';

export const Route = createFileRoute('/_app/settings/tags')({
    component: TagsPage,
});

function TagsPage() {
    const { organizationId, gates } = useSettingsGates();
    if (!gates.canManageOrgSettings) {
        return <Navigate to="/settings" replace={true} />;
    }
    if (organizationId === null) {
        return null;
    }
    return (
        <SettingsPageShell
            title="Tags"
            description="Tell Phoebe what each tag means."
            maxWidth="wide"
        >
            <TagDefinitionsSection organizationId={organizationId} />
        </SettingsPageShell>
    );
}
